/* ============================================================
   Kaynaturalz — interactions (Shopify build)

   CART STATE RULES
   1. The drawer is a painted snapshot, not live data. Anything that
      opens it must repaint it first, or the shopper sees whatever was
      there at page load. That is what made Quick Add on the collection
      page look broken. KNCart.open() now refreshes before it opens.
   2. Every cart mutation returns the new cart, and we paint from that
      response rather than assuming what the cart became. Shopify caps
      quantity at available stock, so the response is the truth.
   3. One change at a time. cartBusy blocks overlapping requests so a
      fast double tap on + cannot race itself.
   ============================================================ */
(function () {
  "use strict";

  var SHIP_PROTECT_VARIANT = 46592793837782;   // flat add-on, no stepper

  /* ---------- DATA (matches the design + live catalog) ---------- */
  var CDN = "https://cdn.shopify.com/s/files/1/0411/3262/1976/files/";
  var PRODUCTS = [
    { title: "Duo Skincare Bundle", desc: "Simple two-step routine for cleansing & glow", price: 42.94, rating: 4.9, img: CDN + "bundle-tumeric.jpg?v=1784822838", url: "/products/duo-skincare-bundle", variantId: null, badges: [["Beginner Pick","dark"]] },
    { title: "Organic Turmeric Soap Bar", desc: "Brightening goat-milk cleansing bar for dark marks & uneven tone — now 5 oz", price: 14.99, compareAt: 23.0, rating: 4.9, img: CDN + "kn-tum-front.png?v=1784835388", url: "/products/organic-turmeric-soap-bar", variantId: 44831452299478, badges: [["New · 5 oz","brick"],["Best Seller","gold"]] },
    { title: "Glow Oil", desc: "Moisture-locking glow oil for scars, dry patches & radiance", price: 23.0, rating: 4.9, img: CDN + "DSC01925.jpg?v=1756747606", url: "/products/glow-oil", variantId: 44831453741270, badges: [["Routine Essential","dark"]] },
    { title: "Organic Oat Soap Bar", desc: "Gentle, soothing goat-milk bar for sensitive, irritated or eczema-prone skin — now 5 oz", price: 14.99, compareAt: 23.0, rating: 4.9, img: CDN + "kn-oat-front.png?v=1784835388", url: "/products/untitled-jan2_20-48", variantId: 44831485755606, badges: [["New · 5 oz","brick"],["Sensitive Skin","dark"]] }
  ];

  var ED = CDN;
  var CONCERNS = [
    { title: "Dark Marks & Hyperpigmentation", desc: "Target stubborn dark marks with a routine made for consistency.", img: ED + "DSC03881.jpg", url: "/products/organic-turmeric-soap-bar" },
    { title: "Acne Scars & Breakouts", desc: "Calm breakouts and fade the marks they leave behind.", img: ED + "DSC03925.jpg", url: "/products/organic-turmeric-soap-bar" },
    { title: "Sensitive or Eczema Prone", desc: "Gentle, soothing formulas for reactive skin.", img: ED + "DSC03982.jpg", url: "/products/untitled-jan2_20-48" },
    { title: "Dull or Uneven Tone", desc: "Bring back radiance with brightening botanicals.", img: ED + "DSC03916.jpg", url: "/products/glow-toner" },
    { title: "Face & Body Glow", desc: "A head-to-toe routine for visible, even glow.", img: ED + "DSC04036.jpg", url: "/products/fade-glow-bundle" },
    { title: "Beginner Friendly Routine", desc: "Start simple. Stay consistent. See results.", img: ED + "DSC04095.jpg", url: "/products/duo-skincare-bundle" }
  ];

  var LOOKBOOK = ["DSC03882","DSC04082","DSC03954","DSC03894","DSC04037","DSC04102","DSC03981","DSC03847"].map(function (f) { return ED + f + ".jpg"; });
  var IRL = ["DSC03873","DSC03891","DSC03955","DSC04034","DSC04068","DSC04078"].map(function (f) { return ED + f + ".jpg"; });

  var TRUST = ["Handmade Small Batch","Cruelty Free","No Parabens","No Sulfates","Sensitive Skin Friendly","Natural Ingredients","Secure Checkout","Free Shipping $75+"];

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var money = function (n) { return "$" + n.toFixed(2); };
  var moneyCents = function (c) { return "$" + (c / 100).toFixed(2); };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (ch) { return ({ "&":"&amp;", "<":"&lt;", ">":"&gt;", '"':"&quot;", "'":"&#39;" })[ch]; }); };
  var el = function (html) { var t = document.createElement("template"); t.innerHTML = html.trim(); return t.content.firstChild; };

  /* ---------- RENDER: products ---------- */
  function renderProducts() {
    var grid = $("#productGrid");
    if (!grid) return;
    PRODUCTS.forEach(function (p) {
      var badges = p.badges.map(function (b) {
        return '<span class="badge badge--' + b[1] + '">' + b[0] + "</span>";
      }).join("");
      var stars = "★★★★★";
      var media = '<a href="' + p.url + '" style="display:block;width:100%;height:100%;"><img src="' + p.img + '" alt="' + p.title + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;"></a>';
      var addAttr = p.variantId
        ? 'data-variant="' + p.variantId + '" data-add="' + p.title + '"'
        : 'data-href="' + p.url + '"';
      var card = el(
        '<article class="pcard">' +
          '<div class="pcard__media">' +
            '<div class="pcard__badges">' + badges + "</div>" +
            media +
          "</div>" +
          '<div class="pcard__body">' +
            '<h3 class="pcard__title"><a href="' + p.url + '" style="color:inherit;text-decoration:none;">' + p.title + "</a></h3>" +
            '<p class="pcard__desc">' + p.desc + "</p>" +
            '<span class="stars"><span class="stars__icons">' + stars + "</span> " + p.rating.toFixed(1) + "</span>" +
            '<div class="pcard__price">' + money(p.price) + (p.compareAt ? ' <s style="color:var(--taupe-soft);font-weight:400;font-size:.72em;">' + money(p.compareAt) + '</s>' : '') + "</div>" +
            '<button class="pcard__add" ' + addAttr + '>Quick Add</button>' +
          "</div>" +
        "</article>"
      );
      grid.appendChild(card);
    });
  }

  /* ---------- RENDER: concerns ---------- */
  function renderConcerns() {
    var grid = $("#concernGrid");
    if (!grid) return;
    CONCERNS.forEach(function (c) {
      grid.appendChild(el(
        '<a class="concern" href="' + (c.url || "#concern") + '">' +
          '<img class="tile-img" src="' + c.img + '" alt="' + c.title + '" loading="lazy">' +
          '<div class="concern__body">' +
            "<h3>" + c.title + "</h3>" +
            "<p>" + c.desc + "</p>" +
            '<span class="concern__link">Shop now →</span>' +
          "</div>" +
        "</a>"
      ));
    });
  }

  /* ---------- RENDER: lookbook + irl ---------- */
  function renderGallery(id, files) {
    var box = $("#" + id);
    if (!box) return;
    files.forEach(function (src) {
      box.appendChild(el('<figure><img src="' + src + '" alt="Kaynaturalz editorial" loading="lazy"></figure>'));
    });
  }

  /* ---------- RENDER: marquee ---------- */
  function renderMarquee(id) {
    var track = $("#" + id);
    if (!track) return;
    var dot = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="4"/></svg>';
    var list = TRUST;
    /* Outside the US there is no free-shipping offer to advertise. */
    if (window.KN_FREE_SHIP === false) {
      list = TRUST.filter(function (t) { return !/free\s*shipping/i.test(t); });
    }
    var items = list.concat(list).map(function (t) {
      return '<span class="marquee__item">' + dot + t + "</span>";
    }).join("");
    track.innerHTML = items;
  }

  /* ---------- CART — real Shopify AJAX cart ---------- */
  var cartBusy = false;

  function openDrawer(d) { d.classList.add("open"); $("#overlay").classList.add("open"); document.body.style.overflow = "hidden"; }
  function closeAll() {
    $("#cartDrawer").classList.remove("open");
    $("#mobilenav").classList.remove("open");
    $("#overlay").classList.remove("open");
    document.body.style.overflow = "";
  }

  function showCartNote(msg) {
    var body = $("#cartBody");
    if (!body) return;
    var old = body.querySelector(".cart-note");
    if (old) old.parentNode.removeChild(old);
    var n = document.createElement("p");
    n.className = "cart-note";
    n.setAttribute("role", "status");
    n.textContent = msg;
    body.insertBefore(n, body.firstChild);
    setTimeout(function () { if (n.parentNode) n.parentNode.removeChild(n); }, 4000);
  }

  function renderCart(cart) {
    var body = $("#cartBody"), foot = $("#cartFoot"), countEl = $("#cartCount");
    if (!body || !foot || !countEl) return;
    var qty = cart.item_count;
    if (qty > 0) { countEl.hidden = false; countEl.textContent = qty; } else { countEl.hidden = true; countEl.textContent = "0"; }
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-empty"><p>Your cart is empty</p><a href="/collections/all-products" class="btn btn--dark" id="cartShop">Shop the collection</a></div>';
      foot.hidden = true;
      return;
    }
    var lines = cart.items.map(function (it, idx) {
      var line = idx + 1;
      var vid = it.variant_id || it.id;
      var img = it.image
        ? '<img src="' + it.image + '" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:10px;">'
        : '<div class="ph"><span>·</span></div>';
      var variant = (it.variant_title && it.variant_title !== "Default Title") ? " · " + it.variant_title : "";

      var qtyCtl;
      if (vid === SHIP_PROTECT_VARIANT) {
        qtyCtl = '<span class="cart-line__qty">Qty ' + it.quantity + "</span>";
      } else {
        qtyCtl =
          '<div class="qtybox">' +
            '<button type="button" class="qtybox__b" data-line="' + line + '" data-to="' + (it.quantity - 1) + '" data-vid="' + vid + '" aria-label="Decrease quantity"' + (it.quantity <= 1 ? " disabled" : "") + ">&minus;</button>" +
            '<span class="qtybox__n" aria-live="polite">' + it.quantity + "</span>" +
            '<button type="button" class="qtybox__b" data-line="' + line + '" data-to="' + (it.quantity + 1) + '" data-vid="' + vid + '" aria-label="Increase quantity">+</button>' +
          "</div>";
      }

      return '<div class="cart-line">' +
        '<div class="cart-line__img">' + img + "</div>" +
        '<div class="cart-line__info"><h4>' + esc(it.product_title) + esc(variant) + "</h4>" +
          qtyCtl +
          '<div class="cart-line__rm" data-rm="' + line + '" role="button" tabindex="0">Remove</div></div>' +
        '<div class="cart-line__price">' + moneyCents(it.final_line_price) + "</div>" +
      "</div>";
    }).join("");

    body.innerHTML = lines;
    foot.hidden = false;
    $("#cartTotal").textContent = moneyCents(cart.items_subtotal_price);

    /* free-shipping progress ($75 threshold) — US only; the block is not
       rendered at all for other markets, so this simply no-ops there */
    var FREE_SHIP_CENTS = 7500;
    var shipBox = $("#shipProgress"), shipLabel = $("#shipLabel"), shipFill = $("#shipFill");
    if (shipBox && shipLabel && shipFill) {
      var sub = cart.items_subtotal_price;
      var pct = Math.min(100, (sub / FREE_SHIP_CENTS) * 100);
      shipFill.style.width = pct.toFixed(1) + "%";
      if (sub >= FREE_SHIP_CENTS) {
        shipBox.classList.add("done");
        shipLabel.textContent = "🎉 You've unlocked FREE shipping!";
      } else {
        shipBox.classList.remove("done");
        shipLabel.innerHTML = "You're <b>" + moneyCents(FREE_SHIP_CENTS - sub) + "</b> away from free shipping";
      }
    }
  }

  function refreshCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { /* leave the last good paint in place */ });
  }

  /* line is 1-based. quantity 0 removes the line.
     vid lets us verify afterwards what Shopify actually gave us, since
     it silently caps at available stock. */
  function changeLine(line, quantity, vid) {
    if (cartBusy) return Promise.resolve();
    if (!(quantity >= 0)) quantity = 0;
    cartBusy = true;
    var body = $("#cartBody");
    if (body) body.classList.add("is-busy");

    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (vid && quantity > 0) {
          var got = null;
          cart.items.forEach(function (i) { if ((i.variant_id || i.id) === vid) got = i; });
          if (got && got.quantity < quantity) {
            showCartNote("Only " + got.quantity + " available right now.");
          }
        }
        return cart;
      })
      .catch(function () { return refreshCart(); })
      .then(function (cart) {
        cartBusy = false;
        if (body) body.classList.remove("is-busy");
        return cart;
      });
  }

  function addToCart(variantId, qty) {
    var n = parseInt(qty, 10);
    if (!n || n < 1) n = 1;
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: variantId, quantity: n })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function () { return refreshCart(); });
  }

  /* One delegated listener on the cart body, bound once. The old code
     rebound per render, which leaked listeners on every repaint. */
  function bindCartBody() {
    var body = $("#cartBody");
    if (!body || body.getAttribute("data-kn-bound")) return;
    body.setAttribute("data-kn-bound", "1");

    body.addEventListener("click", function (e) {
      var step = e.target.closest(".qtybox__b");
      if (step) {
        if (step.disabled) return;
        changeLine(+step.getAttribute("data-line"), +step.getAttribute("data-to"), +step.getAttribute("data-vid"));
        return;
      }
      var rm = e.target.closest("[data-rm]");
      if (rm) { changeLine(+rm.getAttribute("data-rm"), 0); }
    });

    body.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var rm = e.target.closest("[data-rm]");
      if (rm) { e.preventDefault(); changeLine(+rm.getAttribute("data-rm"), 0); }
    });
  }

  function bindAddButtons() {
    document.querySelectorAll("button[data-variant], button[data-href]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        if (btn.dataset.href) { window.location.href = btn.dataset.href; return; }
        var orig = btn.textContent;
        addToCart(+btn.dataset.variant, 1).then(function () {
          if (btn.classList.contains("pcard__add")) {
            btn.classList.add("added"); btn.textContent = "Added ✓";
            setTimeout(function () { btn.classList.remove("added"); btn.textContent = orig; }, 1300);
          } else {
            openDrawer($("#cartDrawer"));
          }
        }).catch(function (e) {
          btn.textContent = (e && e.description) ? "Sold out" : "Try again";
          setTimeout(function () { btn.textContent = orig; }, 1800);
        });
      });
    });
  }

  /* ---------- ANNOUNCEMENT rotation ---------- */
  function startAnnounce() {
    var msgs = document.querySelectorAll(".announce__msg");
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove("is-on");
      i = (i + 1) % msgs.length;
      msgs[i].classList.add("is-on");
    }, 3800);
  }

  /* ---------- HERO carousel ---------- */
  function startHeroDots() {
    var dots = document.querySelectorAll(".hero__dots i");
    var slides = document.querySelectorAll(".hero__slide");
    if (!dots.length || !slides.length) return;
    var i = 0, timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle("is-on", k === i); });
      dots.forEach(function (d, k) { d.classList.toggle("on", k === i); });
    }
    function auto() { timer = setInterval(function () { go(i + 1); }, 4500); }
    dots.forEach(function (d, k) {
      d.addEventListener("click", function () { clearInterval(timer); go(k); auto(); });
    });
    go(0); auto();
  }

  /* ---------- SCROLL reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("in"); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- shared cart API for other page scripts and sections ---------- */
  window.KNCart = {
    add: addToCart,
    refresh: refreshCart,
    change: changeLine,
    open: function () {
      var d = $("#cartDrawer");
      if (d) openDrawer(d);
      return refreshCart();
    }
  };

  /* ---------- INIT ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    renderProducts();
    renderConcerns();
    renderGallery("lookbook", LOOKBOOK);
    renderGallery("irl", IRL);
    renderMarquee("mq");
    bindAddButtons();
    bindCartBody();
    refreshCart();
    startAnnounce();
    startHeroDots();
    initReveal();

    $("#cartBtn").addEventListener("click", function () { window.KNCart.open(); });
    $("#cartClose").addEventListener("click", closeAll);
    $("#burger").addEventListener("click", function () { openDrawer($("#mobilenav")); });
    $("#mobileClose").addEventListener("click", closeAll);
    $("#overlay").addEventListener("click", closeAll);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeAll(); });

    document.querySelectorAll("#mobilenav a").forEach(function (a) { a.addEventListener("click", closeAll); });
  });

  /* Coming back via the back button serves a cached page whose cart
     markup can be out of date. Repaint from the live cart. */
  window.addEventListener("pageshow", function (e) { if (e.persisted) refreshCart(); });
})();
